import styled from 'styled-components';

/** Location and status, equal halves; one per row on a phone. */
export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 32px;
  margin: 24px 0;

  @media (max-width: 800px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
    margin: 16px 0;
  }
`;
